import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
function RemoveAttachmentModal({
  attachmentName,
  description,
  isOpen,
  onCancelClick,
  onRemoveClick
}) {
  if (!isOpen) {
    return null;
  }
  const message = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "deleteModal.removeTitle",
    options: {
      name: attachmentName
    }
  });
  const confirmLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "deleteModal.remove"
  });
  const rejectLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "deleteModal.cancel"
  });
  return /*#__PURE__*/_jsx(ConfirmModal, {
    confirmLabel: confirmLabel,
    description: description,
    onConfirm: onRemoveClick,
    onReject: onCancelClick,
    message: message,
    rejectLabel: rejectLabel
  });
}
export default RemoveAttachmentModal;